// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Playing = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M27.27 53c2.655 0 4.807 2.239 4.807 5v19c0 2.761-2.152 5-4.807 5H13.808C11.152 82 9 79.761 9 77V58c0-2.761 2.152-5 4.808-5H27.27Zm25.96-17c2.656 0 4.808 2.239 4.808 5v36c0 2.761-2.152 5-4.807 5H39.769c-2.655 0-4.807-2.239-4.807-5V41c0-2.761 2.152-5 4.807-5h13.462Zm25.962-21C81.848 15 84 17.239 84 20v57c0 2.761-2.152 5-4.808 5H65.731c-2.656 0-4.808-2.239-4.808-5V20c0-2.761 2.152-5 4.808-5h13.461ZM13.808 57c-.531 0-.962.448-.962 1v19c0 .552.43 1 .962 1H27.27c.53 0 .96-.448.96-1V58c0-.552-.43-1-.96-1H13.808ZM39.77 40c-.532 0-.962.448-.962 1v36c0 .552.43 1 .962 1h13.46c.532 0 .962-.448.962-1V41c0-.552-.43-1-.962-1H39.77Zm25.96-21c-.53 0-.96.448-.96 1v57c0 .552.43 1 .96 1h13.462c.531 0 .962-.448.962-1V20c0-.552-.43-1-.962-1H65.731Z"
			fill="#000"
		/>
	</svg>
);
export default Playing;
